/* eslint-disable no-shadow */
export enum BasicTypes {
  PLACE = 'places',
  TRIP = 'trips',
  ROUTE = 'routes'
}
/* eslint-enable no-shadow */
